document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('click', function(event) {
        if (event.target.matches('.js-centerDoctorsShowMore')) {
            var clicked = event.target,
                moreList = clicked.parentElement.querySelector('.c-center-doctors__more');

            clicked.style.display = 'none';
            moreList.style.display = 'block';
        }
    });
});
